import React from 'react'

import { Column, Text } from 'Components/UI'

import { NAVIGATION_BASE, NAVIGATION_DROPDOWN } from 'Constants/Navigation'

import { StyledLink } from './styles'

function QuickLinks() {
  return (
    <Column gap={6}>
      <Text bold inverse screen20>
        Quick Links
      </Text>

      <Column as="nav" gap={3}>
        {NAVIGATION_BASE.map(item => (
          <StyledLink href={item.path} key={item.id}>
            <Text inverse medium nowrap screen14>
              {item.label}
            </Text>
          </StyledLink>
        ))}

        {NAVIGATION_DROPDOWN.map(item => (
          <StyledLink href={item.path} key={item.id}>
            <Text inverse medium nowrap screen14>
              {item.label}
            </Text>
          </StyledLink>
        ))}
      </Column>
    </Column>
  )
}

export default QuickLinks
